var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"slogan"},[_c('h4',[_vm._v(" "+_vm._s(_vm.$t("slogan"))+" ")])]),_c('div',{staticClass:"s1"},[_c('div',{staticClass:"container"},[_c('markdown',{attrs:{"source":"./jobs.md","lang":_vm.$i18n.locale}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }